import { FiInfo } from '@react-icons/all-files/fi/FiInfo'
import { MdInfo } from '@react-icons/all-files/md/MdInfo'

// some information message presented, more info button

export const IconInfo = FiInfo
export const IconInfoFill = MdInfo
